// Odeslat komentář hlavním formulářem

import { SVGLoader } from '@components';
import * as els from './forumElements';
import { forumSendComment as sendComment } from './formSendComment';
import { forumTextarea } from './forumTextarea';
import { updateButtonState } from './forumValidate';

//  TODO: unit testy https://cncenter.atlassian.net/browse/FEG-657
export const forumAddComment = (): void => {
  // Načíst UI elementy
  const button = els.buttonAddComment;

  if (!button) return;

  const formElement: HTMLElement | null = els.formAddComment;

  if (!formElement) return;

  const textarea: HTMLTextAreaElement | null = formElement.querySelector('textarea');

  const notifyEmailRespond: HTMLInputElement | null = formElement.querySelector('[name="notify"]');

  const threadId: HTMLInputElement | null = formElement.querySelector('[name="threadId"]');

  if (!notifyEmailRespond || !threadId || !textarea) return;

  // Sledovat počet chybějících znaků & autoheight
  if (els.textareaAddComment) forumTextarea(els.textareaAddComment);

  textarea.addEventListener('input', () => {
    updateButtonState({ textarea, button });
  });

  // Initialize button state
  updateButtonState({ textarea, button });

  // Po kliknutí na tlačítko 'Odeslat komentář'
  button.addEventListener('click', (eventAddComment) => {
    eventAddComment.preventDefault();

    // Schovat UI & přidat loader
    [textarea, textarea.nextElementSibling, button, notifyEmailRespond.parentElement].forEach(
      (element) => {
        if (element instanceof HTMLElement) element.style.display = 'none';
      }
    );
    SVGLoader.create({ addTo: formElement });

    // Odeslat data
    sendComment({
      threadId: threadId.value,
      content: textarea.value,
      notifyEmailRespond: notifyEmailRespond.checked,
    });

    // Vyčistit formulář
    textarea.value = '';
  });
};
